import React, { useState } from "react";
import { Card, Collapse, Badge } from "react-bootstrap";

interface DebugSectionProps {
  title: string;
  icon?: string;
  children: React.ReactNode;
  badge?: {
    text: string;
    variant: string;
  };
  extraBadges?: React.ReactNode;
  collapsible?: boolean;
  defaultOpen?: boolean;
}

const DebugSection: React.FC<DebugSectionProps> = ({
  title,
  icon = "",
  children,
  badge,
  extraBadges,
  collapsible = true,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleToggle = () => {
    if (collapsible) {
      setIsOpen(!isOpen);
    }
  };
  const header = (
    <Card.Header
      onClick={collapsible ? handleToggle : undefined}
      style={{ cursor: collapsible ? "pointer" : "default" }}
      className="d-flex justify-content-between align-items-center"
    >
      <h4>
        {icon && `${icon} `}
        {title}
      </h4>
      <div className="d-flex align-items-center gap-2">
        {extraBadges}
        {badge && (
          <Badge bg={badge.variant}>{badge.text}</Badge>
        )}
        {collapsible && (
          <span style={{ fontSize: "18px", userSelect: "none" }}>
            {isOpen ? "▼" : "▶"}
          </span>
        )}
      </div>
    </Card.Header>
  );

  return (
    <Card>
      {header}
      {collapsible ? (
        <Collapse in={isOpen}>
          <Card.Body>{children}</Card.Body>
        </Collapse>
      ) : (
        <Card.Body>{children}</Card.Body>
      )}
    </Card>
  );
};

export default DebugSection;